import { FolderSettings } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const SettingsSuggest: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <FolderSettings width={size} height={size} color={color} {...rest} />;

SettingsSuggest.displayName = 'SettingsSuggest';

export default SettingsSuggest;
